import React, {useMemo} from 'react'
import {PROPERTY_INSTRUCTION_CATEGORIES} from "../../../../services/accommodations/enums";
import PropertyInstructionList from "./PropertyInstructionList";


const PropertyInstruction = ({propertyInstructions, onSave}) => {
    const propertyInstructionsByCategory = useMemo(
        () => {
            const grouped = {};
            (propertyInstructions ?? []).forEach(pi => {
                if (!grouped[pi.category]) {
                    grouped[pi.category] = [];
                }
                grouped[pi.category].push(pi);
            })
            return grouped;
        },
        [propertyInstructions]
    )

    const houseRules = propertyInstructionsByCategory[PROPERTY_INSTRUCTION_CATEGORIES.HOUSE_RULE] ?? [];
    const wifiInstructions = propertyInstructionsByCategory[PROPERTY_INSTRUCTION_CATEGORIES.WIFI] ?? [];

    return <>
        <PropertyInstructionList title="Regole della casa"
                                 propertyInstructionCategory={PROPERTY_INSTRUCTION_CATEGORIES.HOUSE_RULE}
                                 propertyInstructions={houseRules}
                                 onSave={onSave}/>
        <PropertyInstructionList title="Istruzioni Wi-Fi"
                                 propertyInstructionCategory={PROPERTY_INSTRUCTION_CATEGORIES.WIFI}
                                 propertyInstructions={wifiInstructions}
                                 onSave={onSave}/>
    </>
}

export default PropertyInstruction;